import { hot } from 'react-hot-loader/root';
import React from 'react';
import PropTypes from 'prop-types';

import ArchetypeRankingsSection from '../sections/ArchetypeRankingsSection';
import ExploreYourAttributesSection from '../sections/ExploreYourAttributesSection';
import AttributesScienceSection from '../sections/AttributesScienceSection';
import ShopifyProductsSection from '../sections/ShopifyProductsSection';
import phrasesType from '../proptypes/phrases';
import comparisonOptionsType from '../proptypes/comparison-options';
import { contentfulConfigType } from '../proptypes/contentful';
import shopifyConfigType from '../proptypes/shopify-config';
import rankingType, { additionalRankingType } from '../proptypes/ranking';
import attributesConfigType from '../proptypes/attributes-config';
import FallbackModule from '../components/FallbackModule';
import SvgGlobals from '../components/SvgGlobals';
import PhrasesContext from '../components/contexts/PhrasesContext';
import PageWrapper from '../design-system/PageWrapper';
import AccountSubNav from '../components/AccountSubNav';
import LaserBannerPageSection from '../design-system/LaserBannerPageSection';
import { HeadingSection } from '../design-system/Headings';

const AttributesPage = ({
  ranking,
  additionalRanking,
  averageRanking,
  phrases,
  config,
  attributePath,
  gamesPath,
  comparisonOptions,
  sciencePath,
  shopifyConfig,
  shopifyCollection,
  contentfulConfig,
}) => {
  const contentAvailable = ranking;
  const pageTitle = phrases.rankingTitle;

  return (
    <PhrasesContext.Provider value={phrases}>
      <SvgGlobals />
      <PageWrapper tallNav bgDark>
        <AccountSubNav />
        <LaserBannerPageSection>
          <HeadingSection el="h1" my0>{pageTitle}</HeadingSection>
        </LaserBannerPageSection>
        {contentAvailable ? (
          <>
            <ArchetypeRankingsSection
              {...{
                ranking,
                additionalRanking,
                averageRanking,
                phrases,
                config,
                attributePath,
                comparisonOptions,
                contentfulConfig,
              }}
              profiles2
            />
            <ExploreYourAttributesSection
              {...{
                ranking,
                additionalRanking,
                phrases,
                attributePath,
              }}
            />
            <AttributesScienceSection
              {...{
                phrases,
                sciencePath,
              }}
            />
            <ShopifyProductsSection
              count={6}
              title={phrases.giftsAndGadgetsTitle}
              config={shopifyConfig}
              collectionId={shopifyCollection}
              linkText={phrases.giftsAndGadgetsLink}
            />
          </>
        ) : (
          <FallbackModule
            heading={phrases.rankingTitle}
            message={phrases.noDataMessage}
            buttonCopy={phrases.noDataInstruction}
            link={gamesPath}
            themeClassName="module-gray"
          />
        )}
      </PageWrapper>
    </PhrasesContext.Provider>
  );
};

AttributesPage.defaultProps = {
  ranking: null,
  additionalRanking: null,
  attributePath: null,
  comparisonOptions: [],
};

AttributesPage.propTypes = {
  ranking: rankingType,
  additionalRanking: additionalRankingType,
  averageRanking: rankingType.isRequired,
  phrases: phrasesType.isRequired,
  config: attributesConfigType.isRequired,
  gamesPath: PropTypes.string.isRequired,
  attributePath: PropTypes.string,
  comparisonOptions: comparisonOptionsType,
  sciencePath: PropTypes.string.isRequired,
  shopifyConfig: shopifyConfigType.isRequired,
  shopifyCollection: PropTypes.string.isRequired,
  contentfulConfig: contentfulConfigType.isRequired,
};

export default hot(AttributesPage);
